import { __read, __spread } from "tslib";
// There are cases where the context is not available, such as when a dropdown item is used
// inside @atlaskit/navigation. For this reason we have this helper function which safely calls
// the context functions if they are available.
export default (function (instance, contextKey) { return function (fnToCall) {
    var _a;
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (!instance.context[contextKey]) {
        return null;
    }
    return (_a = instance.context[contextKey])[fnToCall].apply(_a, __spread(args));
}; });
//# sourceMappingURL=safeContextCall.js.map